import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const POLISH_PLATES = {
  YES: 'yes',
  NO: 'no',
} as const;

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const POLISH_PLATES_NAME = 'polish_plates';
export const POLISH_PLATES_NAME_COMPLEMENTARY = 'polish_plates_complementary';

export const RadioGroupPolishPlates: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary ? POLISH_PLATES_NAME_COMPLEMENTARY : POLISH_PLATES_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy sprawca miał polskie tablice rejestracyjne?')}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-polish-plates"
            >
              <RadioItem
                value={POLISH_PLATES.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-polish-plates-yes"
              />
              <RadioItem
                value={POLISH_PLATES.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-polish-plates-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
